import {
	Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList,
	ViewChild, ViewChildren, Inject, PLATFORM_ID, OnDestroy
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { keywordList } from 'src/interface/article';
import { themeData } from 'src/interface/themesetting';

@Component({
	selector: 'app-article-keyword-list',
	templateUrl: './article-keyword-list.component.html',
	styleUrls: ['./article-keyword-list.component.scss']
})
export class ArticleKeywordListComponent implements OnInit, OnChanges, OnDestroy {
	@Input() showkeywords: boolean;
	@Input() objectKeywords: string[] = [];
	@Input() journal_id: string;
	@ViewChild('keywords')
	keywords!: ElementRef<HTMLDivElement>;
	public keywordSearchForm: FormGroup;
	public keySearchData: { keySearchValue: FormControl; };
	@ViewChildren('keywordSpan', { read: ElementRef }) spanElements: QueryList<ElementRef>;
	keywordsByFirstLetter: string[] = [];
	@Output() keyword_selected = new EventEmitter<string>();
	search_keywords: string[] = [];
	themeSettingsData: themeData
	subscriptions: Subscription[] = []
	allKeywords: string[] = [];

	constructor(public mainBodyService: MainBodyService, private articleService: GetArticlesService,
		@Inject(PLATFORM_ID) private platformId: any) { }

	ngOnInit(): void {

		this.keywordSearchForm = new FormGroup({
			keySearchValue: new FormControl()
		})
		this.keySearchData = {
			keySearchValue: this.keywordSearchForm.get('keySearchValue') as FormControl
		}
		if (this.journal_id) {
			const themeSub = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result) => {
				if (result.data) {
					this.themeSettingsData = result.data;
					const color = this.themeSettingsData.theme_colors;
					if (isPlatformBrowser(this.platformId)) {
						Object.entries(color).map(([key, value]) => {
							const element = "--" + key;
							const val = value;
							document.documentElement.style.setProperty(element, val);
						});
					}
				}
			});
			this.subscriptions.push(themeSub);
		}
	}

	ngOnChanges() {
		if (this.showkeywords == true) {
			const queryParams: keywordList = { length: 0, start: 0 }
			const keywordsSub = this.articleService.getKeywords(queryParams, this.journal_id).subscribe(result => {
				this.allKeywords = result.keywords;
				this.alphabetsAndKeywords(this.allKeywords);
			})
			this.subscriptions.push(keywordsSub);
		}
	}

	focusToAlphabets(alph: string) {
		const alphKeywords = this.keywords.nativeElement.children;
		for (let i = 0; i < alphKeywords.length; i++) {
			if (alphKeywords[i].children[0].textContent == alph) {
				alphKeywords[i].children[0].scrollIntoView({
					block: 'center'
				});
				alphKeywords[i].children[0].classList.add('highlight');
				setTimeout(() => {
					alphKeywords[i].children[0].classList.remove('highlight');
				}, 1000);
			}
		}
	}

	focustoKeyword() {
		const spanCount = this.spanElements.toArray().length;
		const keyword = this.keywordSearchForm.get('keySearchValue')?.value;
		const regex = new RegExp(keyword, 'gi');
		for (let i = 0; i < spanCount; i++) {
			const id = this.spanElements.toArray()[i].nativeElement?.getAttribute('id');
			this.spanElements.toArray()[i].nativeElement.innerHTML = id;
			if (keyword.length > 0) {
				const data = this.spanElements.toArray()[i].nativeElement.innerHTML.match(regex);
				if (data !== null) {
					const highlightedTerm = `<span style="color:red;background-color:yellow">` + data[0] + `</span>`;
					const content = this.spanElements.toArray()[i].nativeElement.innerHTML.replace(regex, highlightedTerm);
					this.spanElements.toArray()[i].nativeElement.innerHTML = content;
				}
			}
		}
	}
	clickOnEachKeywords(words: string) {
		const ind = this.search_keywords.findIndex(x => x == words);
		if (ind === -1) {
			this.search_keywords.push(words);
		}
		else {
			this.search_keywords.splice(ind, 1);
		}
		this.keyword_selected.emit(words);
	}

	alphabetsAndKeywords(keywords: string[]) {
		this.keywordsByFirstLetter = keywords.reduce((alph, words) => {
			const firstLetter = words[0].toUpperCase();
			if (!alph[firstLetter]) {
				alph[firstLetter] = [words];
			} else {
				alph[firstLetter].push(words);
			}
			return alph;
		}, []);

		this.objectKeywords = Object.keys(this.keywordsByFirstLetter);
		this.objectKeywords.sort();
	}

	ngOnDestroy() {
		this.subscriptions.forEach(x => {
			if (!x.closed) {
				x.unsubscribe();
			}
		});
	}
}

